import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import WishlistsPage from "@/pages/WishlistsPage";
import WishlistDetail from "@/pages/WishlistDetail";
import PublicProfile from "@/pages/PublicProfile";
import Explore from "@/pages/Explore";
import Friends from "@/pages/Friends";
import Settings from "@/pages/Settings";
import Memories from "@/pages/Memories";
import Contact from "@/pages/Contact";
import PasswordPages, { VerifyEmail } from "@/pages/PasswordPages";
import Admin from "@/pages/Admin";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/giris" element={<AuthPage />} />
      <Route path="/iletisim" element={<Contact />} />
      <Route path="/sifre-unuttum" element={<PasswordPages />} />
      <Route path="/sifre-sifirla" element={<PasswordPages />} />
      <Route path="/dogrula" element={<VerifyEmail />} />
      <Route element={<Layout />}>
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/listelerim" element={<Protected><WishlistsPage /></Protected>} />
        <Route path="/liste/:id" element={<WishlistDetail />} />
        <Route path="/w/:id" element={<WishlistDetail />} />
        <Route path="/kesfet" element={<Explore />} />
        <Route path="/arkadaslar" element={<Protected><Friends /></Protected>} />
        <Route path="/ayarlar" element={<Protected><Settings /></Protected>} />
        <Route path="/anilar" element={<Protected><Memories /></Protected>} />
        <Route path="/admin" element={<Protected><Admin /></Protected>} />
        <Route path="/:username" element={<PublicProfile />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LangProvider>
        <BrowserRouter>
          <AppRouter />
          <WhatsAppFab />
          <Toaster position="top-center" richColors offset={76} mobileOffset={76} />
        </BrowserRouter>
        </LangProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
